import { HttpParams } from '@angular/common/http';

export class HttpParamsUtil {
    
    /**
     * Convierte un objeto plano en HttpParams, omitiendo valores nulos o vacíos.
     * @param filter Objeto con los criterios de búsqueda
     */
    static buildParams(filter: any): HttpParams {
        let params = new HttpParams();

        if (filter) {
            Object.entries(filter).forEach(([key, value]) => {
                // Verificación de valores válidos
                if (value !== null && value !== undefined && value !== '') {
                    // Si el valor es un booleano o número, toString() lo convierte correctamente
                    params = params.append(key, value.toString());
                }
            });
        }

        return params;
    }
}